import { RoseSocket } from "./rosesocket";
import { RosePacket } from "./rosepacket";
import { EventEmitter } from "../util/eventemitter";

export const RESULT_CREATE_CHAR = {
    OK: 0x00,
    FAILED: 0x01,
    DUP_NAME: 0x02,
    INVALID_NAME: 0x03,
    NO_MORE_SLOT: 0x04,
    BLOCKED: 0x05,
    NEED_PREMIUM: 0x06,
};

export class WorldClient extends EventEmitter {
    socket: any;

    constructor() {
        super();
        this.socket = new RoseSocket();
        this.socket.name = "ws";
        this.socket.on("connect", () => {
            netConsole.debug("WorldClient connected");
        });
        this.socket.on("end", () => {
            netConsole.debug("WorldClient ended");
        });
    }

    son(event: any, handler: any) {
        const interHandler = (...args: any[]) => {
            if (!handler.apply(this, args)) {
                this.socket.removeEventListener(event, interHandler);
            }
        };
        this.socket.addEventListener(event, interHandler);
    }

    connect(
        host: any,
        port: any,
        transferKey: any,
        password: any,
        callback: any
    ) {
        this.socket.connect(host, port);
        this.son("connect", function(this: any) {
            const pak = new RosePacket(0x70b);
            pak.addUint32(transferKey);
            pak.addString(
                CryptoJS.MD5(password).toString(CryptoJS.enc.Hex),
                true
            );
            this.socket.sendPacket(pak);
            this.son("packet", function (pak: any) {
                if (pak.cmd !== 0x70c) {
                    console.warn("received unexpected preconn packet");
                    return true;
                }
                callback();
            });
        });
    }

    end() {
        this.socket.end();
    }

    characterList(callback: any) {
        let opak = new RosePacket(0x712);
        this.socket.sendPacket(opak);

        //   this.son('packet', function(pak) {
        //     if (pak.cmd !== 0x712) {
        //       return true;
        //     }

        this.son("packet", function (pak: any) {
            if (pak.cmd !== 0x0712) {
                return true;
            }

            const data: any = {};
            const charCount = pak.readUint8();
            data.canManageGm = pak.readUint8() === 1;
            data.characters = [];

            for (let i = 0; i < charCount; ++i) {
                const chdata: any = {};
                chdata.name = pak.readString();

                // pak.readUint8(); // skip 0x00 placeholder byte na naam (zoals server's ADDBYTE(pak, 0x00))

                chdata.gender = pak.readUint8(); // server's sex

                chdata.level = pak.readUint16();
                chdata.job = pak.readUint16();

                chdata.deleteTime = pak.readUint32();

                pak.readUint8(); // skip 0x00 platinum placeholder byte

                chdata.face = pak.readUint32();
                chdata.hairStyle = pak.readUint32();
                chdata.zoneNo = pak.readUint32();

                chdata.parts = [];
                for (let j = 0; j < 10; j++) {
                    const item: any = {};
                    item.itemNo = pak.readUint16();
                    item.refine = pak.readUint16();
                    chdata.parts.push(item);
                }

                chdata.isGm = pak.readUint8() === 1;

                data.characters.push(chdata);
            }

            callback(data);
        });
    }

    selectCharacter(charName: any, callback: any) {
        let opak = new RosePacket(0x715);
        opak.addUint8(0);
        opak.addUint8(0x6d);
        opak.addUint8(0x16);
        opak.addString(charName);
        this.socket.sendPacket(opak);

        this.son("packet", function (pak: any) {
            if (pak.cmd !== 0x711) {
                return true;
            }

            const data: any = {};
            data.gamePort = pak.readUint16();
            data.transferKey1 = pak.readUint32();
            data.transferKey2 = pak.readUint32();
            data.gameIp = pak.readString();
            callback(data);
        });
    }

    deleteCharacter(
        index: any,
        name: any,
        doDelete: any,
        callback: any
    ) {
        let opak = new RosePacket(0x714);
        opak.addUint8(index);
        opak.addUint8(doDelete);
        opak.addString(name);
        this.socket.sendPacket(opak);

        this.son("packet", function (pak: any) {
            if (pak.cmd !== 0x714) {
                return true;
            }

            const data: any = {};
            data.deleteTime = pak.readUint32();
            data.name = pak.readString();
            callback(data);
        });
    }

    setCharacterGm(
        name: string,
        isGm: boolean,
        callback: (data: { result: number; name: string }) => void
    ) {
        const opak = new RosePacket(0x7f0);
        opak.addUint8(isGm ? 1 : 0);
        opak.addString(name);
        this.socket.sendPacket(opak);

        this.son("packet", function (pak: any) {
            if (pak.cmd !== 0x7f0) {
                return true;
            }

            callback({ result: pak.readUint8(), name: pak.readString() });
        });
    }

    createCharacter(
        name: any,
        gender: any,
        face: any,
        hairStyle: any,
        hairColor: any,
        callback: any
    ) {
        console.log(
            "name",
            name,
            "gender",
            gender,
            "face",
            face,
            "hairStyle",
            hairStyle,
            "hairColor",
            hairColor || 0
        );
        const opak = new RosePacket(0x713);
        opak.addUint8(gender);
        opak.addUint32(hairColor || 0);
        opak.addUint32(hairStyle);
        opak.addUint32(face);
        opak.addUint32(0); // "Weapon Type"
        opak.addUint32(0); // "Zone No"
        opak.addString(name);
        this.socket.sendPacket(opak);

        this.son("packet", function (pak: any) {
            if (pak.cmd !== 0x713) {
                return true;
            }

            const data: any = {};
            data.result = pak.readUint8();
            callback(data);
        });
    }
}

